import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerContainer = styled.div`
  display: inline-block;
  width: 50px;
  height: 50px;

  &:after {
    content: " ";
    display: block;
    width: 36px;
    height: 36px;
    margin: 8px;
    border-radius: 50%;
    border: 4px solid #4a90e2;
    border-color: #4a90e2 transparent #4a90e2 transparent;
    animation: ${spin} 1.2s linear infinite;
  }
`;

interface SpinnerProps {
  size?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ size = '50px' }) => {
  return (
    <SpinnerContainer style={{ width: size, height: size }} />
  );
};

export default Spinner; 